import React from 'react';

import { BalaklavaIcon } from '@vlabs/icons';
import { calculateProbabilityPercent } from '@vlabs/monokit/shared/lib/utils';
import { Tag } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { BaseVideoAnalyticsDetails } from '../../components/BaseVideoAnalyticsDetails';
import type { AnalyticDetailsEvent } from '../../types';

interface FacecoverDetection extends Record<string, unknown> {
  detection?: Record<string, unknown>;
}

type FacecoverV2Event = AnalyticDetailsEvent & {
  event: AnalyticDetailsEvent['event'] & {
    best_detection?: FacecoverDetection;
    overview?: AnalyticDetailsEvent['event']['overview'] & {
      detection?: Record<string, unknown>;
    };
  };
};

export function FacecoverV2Details({ event }: { event: FacecoverV2Event }): React.JSX.Element {
  const { t } = useTranslation();
  const subtype = event.event_type;
  const score = calculateProbabilityPercent(event.event.best_detection?.[`${subtype}_score`]);
  const detection = event.event.overview?.detection
    ?? event.event.best_detection?.detection;

  return (
    <BaseVideoAnalyticsDetails
      detections={detection ? [detection] : []}
      detectionSettingsLabel={t('videoAnalytics:facecoverAnalyticDetailsV2.workspace.detection switch.label')}
      detectionType="bbox"
      event={event}
      tags={(
        <React.Fragment>
          <Tag
            data-testid="workspace.analyticEventDetails.tagType"
            kind="neutral"
            size="large"
            value={t(`videoAnalytics:facecoverAnalyticDetailsV2.subtypes.${subtype}`)}
          />

          <Tag
            data-testid="workspace.analyticEventDetails.extraTagType"
            icon={<BalaklavaIcon />}
            kind="neutral"
            size="large"
            value={`${t('videoAnalytics:facecoverAnalyticDetailsV2.workspace.tag.label')} ${score}%`}
          />
        </React.Fragment>
      )}
      title={t('videoAnalytics:facecoverAnalyticDetailsV2.workspace.title')}
    />
  );
}
